import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 4336ADDD-7A8E-46E7-A886-3873CCCFD3DA
 * name checkbox-marked-circle
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/checkbox-marked-circle.svg
 * tags
 * - Form 
 */
export const CheckboxMarkedCircleIcon = createSvgIcon(<><path d="M10,17L5,12L6.41,10.58L10,14.17L17.59,6.58L19,8M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" /></>, 'CheckboxMarkedCircleIcon');
export default CheckboxMarkedCircleIcon